import React, { ReactElement } from 'react';
import './index.css';

export interface HeroPagesProps {
  title: string;
  description: string;
  bgImage: string;
  bgImageMobile?: string;
  bgPosition?: string;
  children?: React.ReactNode;
}

export const HeroPages = ({
  title,
  description,
  bgImage,
  bgImageMobile,
  bgPosition,
  children,
}: HeroPagesProps): ReactElement => {
  return (
    <div className="hero-pages-container">
      {bgImage && (
        <img
          src={bgImage}
          alt={title}
          className={`hero-pages-bg ${bgImageMobile ? 'desktop-only' : ''} `}
          style={{ objectPosition: bgPosition || 'center' }}
        />
      )}
      {bgImageMobile && (
        <img
          src={bgImageMobile}
          alt={title}
          className="hero-pages-bg mobile-only "
          style={{ objectPosition: bgPosition || 'center' }}
        />
      )}
      <div className="hero-pages-overlay" />
      <div className="hero-pages-content">
        <h1 className="hero-pages-title title-bryant">{title}</h1>
        <p className="hero-pages-description">{description}</p>
        {children}
      </div>
    </div>
  );
};

export default HeroPages;
